import {Locale} from '@hebcal/hdate';
import poData from './ro.po.js';
Locale.addLocale('ro', poData);
